import type { AncestryDefinition, CharacterOptions } from '../../shared/game/character-build.js';

export const orc: AncestryDefinition = {
  id: 'orc', name: 'Orc', size: 'medium', trait: 'Relentless', skillBonus: 0, initiativeBonus: 0, skillBonuses: { might: 1 }, relentless: true,
  description: 'Just when you think you’ve bested a mighty Orc, you’ve merely succeeded in rousing their anger. Engaging in combat with an Orc is no endeavor for the weak-willed. While others may cower before death’s approach, Orcs boldly defy its grasp.',
  traitDescription: '(1/Safe Rest) When you would drop to 0 HP, you may set your HP to LVL instead. +1 Might.',
  languages: [{ id: 'goblin', name: 'Orcish', minimumIntelligence: 0 }],
  languageDescription: 'You know Goblin if your INT isn’t negative (but you call it Orcish, of course).',
  skinColors: [0x78945b, 0x617d48, 0x506d42, 0x879369, 0x646c43, 0x435638, 0x9aa57a, 0x394d38],
};
export const orcBodies: CharacterOptions['bodies'] = [
  { id: 'orc-male', name: 'Masculine', height: [1.8, 2.1], ancestryId: 'orc' },
  { id: 'orc-female', name: 'Feminine', height: [1.7, 2], ancestryId: 'orc' },
];
